import ImageWithFallback from "components/ImageWithFallback"
import React from "react"
import {Component} from "react"
import {Link} from "react-router-dom"
import {Card} from "semantic-ui-react"


export default class CategoryCard extends Component {

	render() {
		const {category, hasParents, className = "", title = true, fallback = "//placehold.it/420x240/f5f5f5/&text=X"} = this.props
		if ( !hasParents ) {
			return <Card className={`CategoryCard ${className}`} as={Link}
						 to={`/collection/${category.map_id}`}>

				<ImageWithFallback src={category.img_src} fallback={fallback} />
				{title && <div className={"category-title-container pa3 text-boxpa3 text-box"}>
					<span className="category-title">{category.desc.short_des}</span>
				</div>}
			</Card>
		}

		if ( category.getParents ) {
			let parents = category.getParents()
			return <Card className={`CategoryCard ${className}`} as={Link}
						 to={`/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}`}>
				<ImageWithFallback src={category.img_src} fallback={"//placehold.it/420x240/f5f5f5ff/&text=X"} />
				{title && <div className={"category-title-container pa3 text-box"}>
					<span className={"category-title"}>{category.desc.short_des}</span>
				</div>}
			</Card>
		}

		return null
	}
}


// WEBPACK FOOTER //
// ./src/plugin/CategoryShortcuts/CategoryCard.js